import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { LogService } from '../../shared/log/log.service';
import { OoivRule } from '../models/ooiv-rule';
import { OoivRulesHttpService } from './ooiv-rules.http.service';

@Injectable()
export class OoivRulesStore {

  // This is the same as BehaviorSubject but without a default value
  private ooivRulesList: ReplaySubject<List<OoivRule>> = new ReplaySubject<List<OoivRule>>(1);

  constructor(private ooivRulesHttpService: OoivRulesHttpService,
              private logService: LogService,
              private flashMessagesService: FlashMessagesService,
              private translateService: TranslateService) {
  }

  getVendorOoivExceptionRules(eventPartyId: number): Observable<OoivRule> {
      return this.ooivRulesList
        .map(rules => rules != null ? rules.filter(rule => rule.eventPartyId === eventPartyId)[0] : null);
  }

  getAnyOoivExceptionRule(): Observable<OoivRule> {
    return this.ooivRulesList
      .map(rules => rules != null ? rules.filter(rule => rule.ooivExceptionsIsValid === false && rule.isAgency === false)[0] : null);
  }

  getAgencyOoivExceptionRule(): Observable<OoivRule> {
    return this.ooivRulesList
      .map(rules => rules != null ? rules.filter(rule => rule.ooivExceptionsIsValid === false && rule.isAgency === true)[0] : null);
  }

  loadOoivExceptionRules(eventId: number): Observable<List<OoivRule>> {
    return this.ooivRulesHttpService.getOoivRules(eventId)
      .catch(error => {
        this.flashMessagesService.error(this.translateService.instant('MESSAGES.ERROR.GET_OOIV_RULES'));
        this.logService.error(`Error fetching OOIV rules: ${error}`);
        return Observable.throw(error);
      })
      .map((result: List<OoivRule>) => {
        this.ooivRulesList.next(result);
        return result;
      });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/ooiv-rules.store.ts